import React, { useState, useEffect } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";

// Mock data for each module
const mockData = {
  Orders: [
    { id: 1, orderId: "ORD001", customer: "John Doe", total: "$100" },
    { id: 2, orderId: "ORD002", customer: "Jane Smith", total: "$150" },
  ],
  Products: [
    { id: 1, productName: "Laptop", category: "Electronics", price: "$1000" },
    { id: 2, productName: "Chair", category: "Furniture", price: "$150" },
  ],
  Customers: [
    { id: 1, name: "John Doe", email: "john@example.com", phone: "1234567890" },
    {
      id: 2,
      name: "Jane Smith",
      email: "jane@example.com",
      phone: "0987654321",
    },
  ],
};

const GlobalSearch = ({
  searchTerm,
  selectedModule,
  setResultfound,
  resultFound,
}) => {
  const [results, setResults] = useState(null);
  const [searching, setSearching] = useState(false); // New state to track searching process
  const [searchCount, setSearchCount] = useState(0);

  useEffect(() => {
    if (!searchTerm) {
      setResults(null);
      setSearching(false);
      return;
    }

    setSearching(true); // Start searching (removes previous "No results found")
    setResults({}); // Clear previous results
    setSearchCount((prev) => prev + 1); // Increment count when search occurs

    setTimeout(() => {
      let filteredResults = {};

      if (selectedModule === "All Modules") {
        const allResults = Object.entries(mockData).flatMap(
          ([moduleName, data]) =>
            data
              .filter((item) =>
                Object.values(item).some((value) =>
                  value
                    .toString()
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
                )
              )
              .map((item) => ({
                ...item,
                moduleName,
              }))
        );

        filteredResults = allResults.reduce((acc, item) => {
          const { moduleName, ...itemWithoutModule } = item;
          if (!acc[moduleName]) acc[moduleName] = [];
          acc[moduleName].push(itemWithoutModule);
          return acc;
        }, {});
      } else {
        filteredResults[selectedModule] =
          mockData[selectedModule]?.filter((item) =>
            Object.values(item).some((value) =>
              value.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
          ) || [];
      }

      setResults(filteredResults);
      setSearching(false); // Stop searching
    }, 300);
  }, [searchTerm, selectedModule]);

  const noResultsFound =
    !searching &&
    results !== null &&
    (Object.keys(results).length === 0 ||
      Object.values(results).every((items) => items.length === 0));

  useEffect(() => {
    if (typeof setResultfound === "function") {
      setResultfound(noResultsFound ? false : true);
      console.log("Search result found g");
    }
  }, [searchCount, noResultsFound, resultFound]);

  return (
    <div style={{ width: "98%", margin: "20px auto", textAlign: "center" }}>
      {results &&
        Object.entries(results).map(([moduleName, items]) => (
          <div key={moduleName} style={{ marginBottom: "20px" }}>
            <p className="text-start text-orange-500 font-semibold">
              {moduleName.charAt(0).toUpperCase() + moduleName.slice(1)}
            </p>
            <TableContainer className="card card-detail mt-1">
              <Table variant="simple" size="sm" style={{ width: "100%" }}>
                <Thead>
                  <Tr className="tr-border">
                    {Object.keys(items[0]).map((header) => (
                      <Th
                        key={header}
                        style={{
                          padding: "2px",
                          background: "#f4f4f4",
                          borderBottom: "2px solid #ccc",
                          fontSize: "14px",
                        }}
                      >
                        {header.toUpperCase()}
                      </Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  {items.map((item, index) => (
                    <Tr key={index} className="tr-border">
                      {Object.values(item).map((value, i) => (
                        <Td
                          key={i}
                          style={{ padding: "10px", fontSize: "14px" }}
                        >
                          {value}
                        </Td>
                      ))}
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </div>
        ))}
    </div>
  );
};

export default GlobalSearch;